// books/essays.js
const essays = {
    project_hail_mary: "not ready.",
    speaker_for_the_dead: "not ready.",
    children_of_the_mind: "not ready.",
    xenocide: "not ready.",
    the_hobbit: "not ready.",
    the_fellowship_of_the_ring: "not ready.",
    the_martian: "not ready.",
    the_maze_runner: "not ready.",
    the_scorch_trials: "not ready.",
    the_death_cure: "not ready.",
    frankenstein: `I think my main take away from this story was when Frankenstein transitioned from a small town boy to enrolling in university in Ingolstadt. 
The way Mary described the pure motivation and thirst for knowledge throughout his scientific work is something that I think everyone can relate to.
It was his passion for continuous learning and discovery that was the backbone of his great scientific discoveries.
This feeling or state of mind is one where you are able to consistently find nuggets of joy within your work and do not feel burdened by the effort it takes to complete it.
In my opinion, it was not hard work or drill-like dedication that allowed for his success to create a monster, but instead his intrinsic curiosity.
I as individual constantly find myself seeking this deeper ambition for knowledge in whatever I am working on.
Sometimes it is easy to find, other times it is a struggle. But I think that it is this drive that separates good work from great work,
especially within a modern world that is filled with countless distractions that detract from deep focus and the quality of work one can produce.`,
    enders_game: "not ready."
};
window.essays = essays;

//# sourceMappingURL=books.e66a9d80.js.map
